/**
 * Copyright Mántum All Rights Reserved.
 */
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

type PropTypes = {
    onClick?: () => void;
    visible?: boolean;
};

export default function Reveal(props: PropTypes) {
    return (
        <button
            className='absolute right-0 flex h-10 w-10 cursor-pointer items-center justify-center rounded-e border border-gray-300 bg-slate-100 hover:bg-slate-200'
            data-testid='reveal'
            onClick={props.onClick}
            tabIndex={-1}
            type='button'
        >
            {props.visible ? (
                <EyeIcon className='h-5 w-5' />
            ) : (
                <EyeSlashIcon className='h-5 w-5' />
            )}
        </button>
    );
}
